var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.000976562)",
    fill: "currentColor",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8127 21.4289L22.8129 21.4292C23.0831 21.9393 22.9929 22.1933 22.9507 22.2642C22.9102 22.3323 22.736 22.5303 22.1631 22.5303H1.83816C1.26307 22.5303 1.08878 22.3323 1.04885 22.2653C1.00771 22.1964 0.916008 21.9435 1.18842 21.4291L1.18853 21.4289L11.5235 1.90508C11.5235 1.90499 11.5236 1.90489 11.5236 1.90479C11.6608 1.64602 11.7921 1.50493 11.8827 1.43561C11.9266 1.40203 11.9582 1.3873 11.9754 1.381C11.9917 1.37502 11.9993 1.375 12.001 1.375C12.0027 1.375 12.0101 1.37499 12.0261 1.38079C12.0429 1.38692 12.0742 1.4014 12.1179 1.43474C12.2082 1.50361 12.3398 1.64467 12.4777 1.905L22.8127 21.4289Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.125V15.125",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.625L12 19.625",
    stroke: "currentColor",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor",
    transform: "translate(0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c4d7b180ec022297bdd695289e851d57.svg";
export { ForwardRef as ReactComponent };